<div class="row">
  <div class="row container-style">
    <span class="preinvoicing-data d-flex justify-content-start gap-4">
      <p><b>Sucursal: </b>{{branchName}}</p>
      <p><b>Nro. Corte: </b>{{invoicingCutoffCode}}</p>
      <p><b>Fecha: </b>{{invoicingCutoffDate}}</p>
    </span>
  </div>
  <div class="row container-style mt-2" *ngIf="showPreinvoicingProgress">
    <h6><b>Proceso de Prefacturación</b></h6>
    <app-custom-progress-bar class="mt-2" [show]="true" [heightProgress]="'0.8rem'" [mode]="'determinate'"
      [value]="progressValue" [currentValue]="progressCurrent" [totalValue]="progressTotal" [hiddenTag]="false"
      [finished]="progressFinished" [statusMessage]="progressStatusMessage">
    </app-custom-progress-bar>
  </div>
  <div id="container-liquidation" class="row container-style mt-2" *ngIf="visiblePdf">
    <div id="list">
      <div class="d-flex justify-content-between">
        <p class="mb-2"><b class="style-text">Lista de Errores y Alertas</b></p>
        <app-custom-button [title]="'Exportar'" [label]="'Exportar'" [icon]="'pi pi-file-export'" [width]="'5.5rem'"
          (onClick)="downloadErrorsTxt()"></app-custom-button>
      </div>
      <hr class="my-2">
      <div id="container-alerts" *ngFor="let preInvoicingAlert of preInvoicingAlerts">
        <p [ngClass]="preInvoicingAlert.alertType == 1 ? 'message-error' : 'message-alert'">
          {{preInvoicingAlert.message}}
        </p>
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="d-flex justify-content-end gap-2 mt-3">
    <app-custom-button [title]="'Iniciar'" [label]="'Iniciar'" [disabled]="disabledStart"
      (onClick)="preInvoicing()"></app-custom-button>
    <app-custom-button [title]="'Salir'" [label]="'Salir'" [severity]="'danger'" [disabled]="disabledClose"
      (onClick)="close()"></app-custom-button>
  </div>
</div>